
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.3 13.2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 12v-.4c0-.3-.1-.4-.1-.7-.1-.3-.1-.6-.2-1-.1-.6-.3-1.2-.6-1.7 0-.2 0-.3-.1-.4.1.7.1 1.5.1 2.2-.1.7-.2 1.4-.3 2.2.4.1.9.2 1.3.2v-.2L6 12zm.4.1c0 .1 0 .1 0 0 0 .1 0 .1 0 0 .3.1 1 0 1.2-.2-.6-.6-1.1-1.5-1.6-2.3.1.9.4 1.8.4 2.5zm-2.8-.7c-.4-.3-.8-.5-1-.9s-.6-.5-.7-1c-.3-.3-.5-.7-.6-1.2 0-.2-.1-.3-.1-.4V7c0-.3 0-.5.1-.9 0-.2.1-.3.1-.5s.1-.3.2-.5c0-.2.1-.4.2-.7.1-.4.3-.7.6-1.1l.5-.5.1-.1v-.2C2 3.4 1.2 4.4.9 5.7c-.3 1.4-.1 2.8.7 4.1.6 1 1.4 1.6 2.5 2.1 0 0 0-.1.1-.1l-.1-.1c-.3-.1-.4-.2-.5-.3zM9 2.5s0 .1 0 0c-.1.1 0 .1 0 .2.2.1.4.3.5.4.1.1.3.4.5.6s.3.5.4.8c.2.3.3.8.3 1.1.1.3.1.8.2 1.2v.7c0 .2-.1.3-.1.5-.1.5-.3 1-.4 1.4-.1.1-.1.3-.2.3l-.6.9c-.3.3-.5.5-.9.7-.1 0-.1.1-.2.1 0 0 0 .1.1.1 1.6-.8 2.8-2.6 2.9-4.7C11.4 5 10.2 3.2 9 2.5zM7.7 1.4c-.3-.2-.7-.3-.9-.5V1c-.1.4-.2.8-.3 1.1-.1.6-.1 1.1-.1 1.7v1.7c0 .4.1.9.1 1.2.3.5.3 1 .4 1.6.1.3.1.6.2.9v-.1c0-.3-.1-.6-.1-.9v-1c0-.5.1-1 .2-1.6.1-.6.3-1.2.5-1.8.3-.6.5-1.2.8-1.8v-.1c-.2-.1-.6-.3-.8-.5zm-.8 8.1c-.2-.5-.3-.9-.4-1.4-.2-.4-.3-1-.3-1.4 0-.4-.1-.8-.1-1.1S6 4.9 6 4.5v-2c0-.3.1-.6.1-1v-.3s0-.2.1-.3c0-.1-.1-.1-.2-.1-.3.2-.7.3-1 .4-.4.3-.7.4-1.2.6 0 0-.1 0-.3.1 0 .2.1.3.1.4.1.3.2.7.2.9.1.3.1.5.2.8.2.4.3.9.4 1.3.2.6.3 1.1.6 1.6.3.6.5 1.1.8 1.7.3.5.6 1.1 1 1.6.3.4.6.9 1 1.3l.1.1v-.1c-.2-.2-.3-.3-.3-.5-.4-.4-.6-.9-.7-1.5z","fill":"#d8d9da"}})])
          )
        }
      }
    